import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import classnames from 'classnames';

import {
  Button,
  ButtonGroup,
  Classes,
} from '@blueprintjs/core';

import styles from './PrintButton.module.scss';

const PrintButton = ({ className = '', ...props }) => {
  const [printMode, setPrintMode] = useState(false);

  const enablePrintMode = () => {
    setPrintMode(true);
    setTimeout(() => {
      const forceReflow = document.createElement('div');
      forceReflow.id = 'forceReflow';
      document.body.appendChild(forceReflow);
    }, 100);
  };

  const disablePrintMode = () => {
    setPrintMode(false);
    setTimeout(() => {
      const forceReflow = document.querySelector('#forceReflow');
      forceReflow.parentElement.removeChild(forceReflow);
    }, 100);
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && window.dispatchEvent) {
      setTimeout(() => window.dispatchEvent(new Event('resize')), 200);
    }
  });

  return (
    <>
      <Helmet bodyAttributes={{ 'data-printMode': printMode.toString() }} />

      {!printMode && (
        <Button
          icon="print"
          className={classnames(className, styles.main, Classes.INTENT_PRIMARY)}
          onClick={enablePrintMode}
          {...props}
        >
          Imprimer la fiche
        </Button>
      )}
      {printMode && (
        <ButtonGroup className={classnames(className, styles.main)} {...props}>
          <Button
            icon="print"
            className={Classes.INTENT_SUCCESS}
            onClick={() => {
              window.print();
              disablePrintMode();
            }}
          >
            Confirmer
          </Button>
          <Button
            className={Classes.INTENT_WARNING}
            onClick={disablePrintMode}
          >
            Annuler
          </Button>
        </ButtonGroup>
      )}
    </>
  );
};

export default PrintButton;
